import React from 'react'
import { Image } from '@/atoms/Image'
import { PromoImage } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext/types'

interface Props {
  desktopImage: PromoImage
  tabletImage: PromoImage
  mobileImage: PromoImage
  alt: string
  className?: string
}

const MAX_DESKTOP_WIDTH = 2000
const MAX_TABLET_WIDTH = 1200
const MAX_MOBILE_WIDTH = 856

export const CustomImageBanner: React.FC<Props> = ({ desktopImage, tabletImage, mobileImage, alt, className }) => {
  const desktopWidth = Math.min(desktopImage.width, MAX_DESKTOP_WIDTH)
  const desktopHeight = (desktopImage.height / desktopImage.width) * desktopWidth
  const tabletWidth = Math.min(tabletImage.width, MAX_TABLET_WIDTH)
  const tabletHeight = (tabletImage.height / tabletImage.width) * tabletWidth
  const mobileWidth = Math.min(mobileImage.width, MAX_MOBILE_WIDTH)
  const mobileHeight = (mobileImage.height / mobileImage.width) * mobileWidth

  return (
    <div className={className}>
      <div className="relative @container">
        <div className="relative hidden @4xl:block">
          <Image
            className="h-full w-full rounded-xl"
            src={desktopImage.url}
            alt={alt}
            width={desktopWidth}
            height={desktopHeight}
            quality={75}
            loading="lazy"
          />
        </div>

        <div className="relative hidden @2xl:block @4xl:hidden">
          <Image
            className="h-full w-full rounded-[10px]"
            src={tabletImage.url}
            alt={alt}
            width={tabletWidth}
            height={tabletHeight}
            quality={75}
            loading="lazy"
          />
        </div>

        <div className="relative @2xl:hidden">
          <Image
            src={mobileImage.url}
            alt={alt}
            className="h-full w-full rounded-lg"
            width={mobileWidth}
            height={mobileHeight}
            quality={75}
          />
        </div>
      </div>
    </div>
  )
}
